const props = {
  MuiButtonBase: {
    disableRipple: true,
  },
  MuiCardHeader: {
    titleTypographyProps: { variant: 'h6' },
  },
  MuiTooltip: {
    enterTouchDelay: 0,
    leaveTouchDelay: 3000,
    disableTouchListener: false,
  },
};

export default props;
